/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';
import { Link } from 'react-router-dom';

import { Button, Modal } from '@mairistem/composants';

import { baseUrlApp } from '@/routes';
import { getFichePacsPath } from '@/utils';
import AssistantContext from '@/contexts/AssistantContext';

interface AssistantModalFinProps {
  /** Identifiant de l'individu */
  identifiant: number;
  /** Callback appelé lors de la fermeture de la modal */
  onClose: () => void;
  /** Callback appelé pour réinitialiser l'assistant */
  onReset?: () => void;
}

const AssistantModalFin = (props: AssistantModalFinProps) => {
  const { identifiant, onClose } = props;

  // const [editionOpen, setEditionOpen] = React.useState<boolean>(false);

  const { selectedDeclarationType, conventionDeclaration } =
    React.useContext(AssistantContext);

  const nomPatenaire1 =
    `${conventionDeclaration?.partenaire1?.prenom ?? ''} ${
      conventionDeclaration?.partenaire1?.nomFamille ?? ''
    }`.trim() || 'le partenaire 1';
  const nomPatenaire2 =
    `${conventionDeclaration?.partenaire2?.prenom ?? ''} ${
      conventionDeclaration?.partenaire2?.nomFamille ?? ''
    }`.trim() || 'le partenaire 2';
  const [headerTitle, setHeaderTitle] = React.useState<string>('');
  const [buttonContent, setButtonContent] = React.useState<string>('');
  const [headerDesc, setHeaderDesc] = React.useState<React.ReactNode>(null);
  const accueilPath = baseUrlApp;
  const pacsPATH = getFichePacsPath(
    identifiant,
    selectedDeclarationType === 'projet',
  );

  React.useEffect(() => {
    let title: string;
    let content: string;
    let button = 'Vous rendre sur la fiche du PACS';
    switch (selectedDeclarationType) {
      case 'projet':
        title = 'Fin de création du projet';
        content = `La création du projet de ${nomPatenaire1} et ${nomPatenaire2} est maintenant terminée. `;
        button = 'Vous rendre sur la fiche du projet';
        break;
      case 'dissolution':
        title = 'Fin de la saisie de la dissolution du PACS';
        content = `La saisie de dissolution du PACS de ${nomPatenaire1} et ${nomPatenaire2} est maintenant terminée. `;
        break;
      case 'initiale':
        title = 'Fin de la création du Pacte Civil de Solidarité';
        content = `La création du PACS de ${nomPatenaire1} et ${nomPatenaire2} est maintenant terminée. `;
        break;
      case 'modificative':
        title = 'Fin de la déclaration modificative';
        content = `La déclaration modificative du PACS de ${nomPatenaire1} et ${nomPatenaire2} est maintenant terminée. `;
        break;
      default:
        title = 'Fin de la saisie du PACS';
        content = `La saisie du PACS de ${nomPatenaire1} et ${nomPatenaire2} est maintenant terminée. `;
    }
    setHeaderTitle(title);
    setHeaderDesc(content);
    setButtonContent(button);
  }, [nomPatenaire1, nomPatenaire2, selectedDeclarationType]);

  return (
    <Modal open size="tiny" data-testid="assistant-modal-fin">
      <Modal.Header content={headerTitle} />
      <Modal.Content
        // @ts-expect-error
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <p>{headerDesc}</p>
        <p>Que souhaitez-vous faire ?</p>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1em',
            width: '70%',
            margin: '0 auto',
          }}
        >
          <Button
            fluid
            disabled
            data-testid="assistant-modal-fin-pieces-justificatives"
            content="Gestion des pièces justificatives"
            // eslint-disable-next-line no-alert
            onClick={() => {
              /* setEditionOpen(true); */
            }}
          />
          <Button
            fluid
            disabled
            data-testid="assistant-modal-fin-documents"
            content="Editer les documents"
          />
          <Button
            fluid
            data-testid="assistant-modal-fin-fiche"
            as={Link}
            to={pacsPATH}
            content={buttonContent}
            onClick={onClose}
          />
          <Button
            fluid
            data-testid="assistant-modal-fin-accueil"
            as={Link}
            to={accueilPath}
            content="Revenir à l'accueil"
            onClick={onClose}
          />
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default AssistantModalFin;
